<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Inspiration 3xfotoHeading</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'X3Exp1Image')"
            [blockData]="block.variables?.X3Exp1Image ?? ''"
            [placeholder]="image1Placeholder"
            variable="X3Exp1Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'X3Exp2Image')"
            [blockData]="block.variables?.X3Exp2Image ?? ''"
            [placeholder]="image2Placeholder"
            variable="X3Exp2Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'X3Exp3Image')"
            [blockData]="block.variables?.X3Exp3Image ?? ''"
            [placeholder]="image3Placeholder"
            variable="X3Exp3Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'X3Exp1ImageHref')"
            [blockData]="block.variables?.X3Exp1ImageHref ?? ''"
            [placeholder]="image1HrefPlaceholder"
            variable="X3Exp1ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp1ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.X3Exp1ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'X3Exp2ImageHref')"
            [blockData]="block.variables?.X3Exp2ImageHref ?? ''"
            [placeholder]="image2HrefPlaceholder"
            variable="X3Exp2ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp2ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.X3Exp2ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'X3Exp3ImageHref')"
            [blockData]="block.variables?.X3Exp3ImageHref ?? ''"
            [placeholder]="image3HrefPlaceholder"
            variable="X3Exp3ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp3ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.X3Exp3ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'alt'"
            (handleOnChange)="onChange($event, 'X3Exp1ImageAlt')"
            [blockData]="block.variables?.X3Exp1ImageAlt ?? ''"
            [placeholder]="image1AltPlaceholder"
            variable="X3Exp1ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp2ImageAlt')"
            [blockData]="block.variables?.X3Exp2ImageAlt ?? ''"
            [placeholder]="image2AltPlaceholder"
            variable="X3Exp2ImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp3ImageAlt')"
            [blockData]="block.variables?.X3Exp3ImageAlt ?? ''"
            [placeholder]="image3AltPlaceholder"
            variable="X3Exp3ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp1Heading')"
            [blockData]="block.variables?.X3Exp1Heading ?? ''"
            [placeholder]="heading1Placeholder"
            variable="X3Exp1Heading"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp2Heading')"
            [blockData]="block.variables?.X3Exp2Heading ?? ''"
            [placeholder]="heading2Placeholder"
            variable="X3Exp2Heading"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp3Heading')"
            [blockData]="block.variables?.X3Exp3Heading ?? ''"
            [placeholder]="heading3Placeholder"
            variable="X3Exp3Heading"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp1CtaLink')"
            [blockData]="block.variables?.X3Exp1CtaLink ?? ''"
            [placeholder]="ctaLink1Placeholder"
            variable="X3Exp1CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp1CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.X3Exp1CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp2CtaLink')"
            [blockData]="block.variables?.X3Exp2CtaLink ?? ''"
            [placeholder]="ctaLink2Placeholder"
            variable="X3Exp2CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp2CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.X3Exp2CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X3Exp3CtaLink')"
            [blockData]="block.variables?.X3Exp3CtaLink ?? ''"
            [placeholder]="ctaLink3Placeholder"
            variable="X3Exp3CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X3Exp3CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.X3Exp3CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X3Exp1CtaText')"
            [blockData]="block.variables?.X3Exp1CtaText ?? ''"
            [placeholder]="ctaText1Placeholder"
            variable="X3Exp1CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X3Exp2CtaText')"
            [blockData]="block.variables?.X3Exp2CtaText ?? ''"
            [placeholder]="ctaText2Placeholder"
            variable="X3Exp2CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X3Exp3CtaText')"
            [blockData]="block.variables?.X3Exp3CtaText ?? ''"
            [placeholder]="ctaText3Placeholder"
            variable="X3Exp3CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-4" *ngIf="block.variables?.X3Exp1Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X3Exp1ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X3Exp1Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X3Exp1ImageAlt)"
            /></a>
          </div>
          <div class="col-4" *ngIf="block.variables?.X3Exp2Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X3Exp2ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X3Exp2Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X3Exp2ImageAlt)"
            /></a>
          </div>
          <div class="col-4" *ngIf="block.variables?.X3Exp3Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X3Exp3ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X3Exp3Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X3Exp3ImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-center mt-2">
          <div class="col-4">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X3Exp1Heading)"></p>
          </div>
          <div class="col-4">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X3Exp2Heading)"></p>
          </div>
          <div class="col-4">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X3Exp3Heading)"></p>
          </div>
        </div>
        <div class="row text-center mt-2">
          <div class="col-4">
            <a
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.X3Exp1CtaLink)"
              target="_blank"
              *ngIf="block.variables?.X3Exp1CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X3Exp1CtaText)"
            ></a>
          </div>
          <div class="col-4">
            <a
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.X3Exp2CtaLink)"
              target="_blank"
              *ngIf="block.variables?.X3Exp2CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X3Exp2CtaText)"
            ></a>
          </div>
          <div class="col-4">
            <a
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.X3Exp3CtaLink)"
              target="_blank"
              *ngIf="block.variables?.X3Exp3CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X3Exp3CtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
